/* eslint-disable jira/filename-case */
export const QUERY_PARAM_TEXT = 'text' as const;
export const QUERY_PARAM_EPIC = 'epics' as const;
export const QUERY_PARAM_STATUS_CATEGORY = 'statusCategory' as const;
export const QUERY_PARAM_WARNINGS = 'warnings' as const;
export const QUERY_PARAM_ASSIGNEE = 'assignee' as const;
export const QUERY_PARAM_SORT_BY = 'sortBy' as const;
export const QUERY_PARAM_SORT_ORDER = 'sortOrder' as const;
